module.exports = __webpack_public_path__ + "44e976948994466054aeb1263ad4e6b2.svg";